module.exports = __webpack_public_path__ + "static/media/Bg_Landing.f4d9190a.jpg";